import { render } from "./configErrorComponent.vue?vue&type=template&id=630b1e57"
import script from "./configErrorComponent.vue?vue&type=script&lang=js"
export * from "./configErrorComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__